import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const harbourIslandConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Harbour Island Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Harbour Island, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_harbour_island',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Harbour Island',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Harbour Island Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     upscale residential and mixed use properties of <strong>Harbour Island</strong>. 
     This gated waterfront community in the heart of Tampa sits directly on the 
     Hillsborough River and Tampa Bay giving trees here some of the most 
     demanding growing conditions in the region. Salt, wind, and storm pressure 
     combine to stress trees fast, and our team handles the results with the 
     precision this neighborhood demands.`,

    `We specialize in <strong>precision tree removal and trimming on premium 
     waterfront properties</strong> storm damaged trees near high value 
     residences, overhanging limbs near docks and seawalls, palms weakened 
     by tidal exposure, and careful full removals in the tight, beautifully 
     maintained spaces that define Harbour Island living.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>Harbour Island</strong> and across 
     <strong>Downtown and South Tampa</strong> keeping premier properties 
     safe, beautiful, and storm-ready through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Harbour Island, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_HarbourIsland = () => <LocationPage config={harbourIslandConfig} />;
export default Services_HarbourIsland;
